export default "__VITE_ASSET__D25CZyEB__"